import React, { useContext, useEffect } from 'react';
import { Watermark, APIAlert } from '@mummssoftware/common-ui';
import { VisitLogContext } from '../Context/VisitLogContext';
import { AppContext } from '../../context';
import { VisitLogTable } from './VisitLogTable';
import { Container } from '../../components/layout/WrapperDiv';
import { SET_API_ERROR } from '../Context/constants';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string | undefined;
}>;

type PatientVisitsProps = {
  patient?: mumms.patient;
  currentUser: mumms.User;
  appTitle?: string;
  smallWidget?: boolean;
  errorInfo?: mumms.ErrorInfo;
  clearError: () => void;
} & typeof RouteProps;

export const VisitLog = ({
  smallWidget,
  errorInfo,
  clearError,
}: PatientVisitsProps) => {
  const { watermark, startLoadingTime, onWidgetReady } = useContext(AppContext);
  const { APIError, dispatch } = useContext(VisitLogContext);

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;

    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('PatientVisits' as mumms.ComponentName);
    console.log('## PATIENT VISIT LOG WIDGET END ##', loadingDuration, 's');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container id="visit-log-container">
      {/* errorInfo is from AppContext which is read-only to most components, need an 
      additional alert to capture API errors that occur after loading initial data. */}
      <APIAlert errorInfo={errorInfo} handleClose={() => clearError()} />
      <APIAlert
        errorInfo={APIError}
        handleClose={() => dispatch({ type: SET_API_ERROR, payload: null })}
      />
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <div style={{ height: '100%' }}>
        <VisitLogTable smallWidget={smallWidget} />
      </div>
    </Container>
  );
};

export default VisitLog;
